import React from "react";
// import MemberShipPriceCard from "./MemberShipPriceCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupee } from "@fortawesome/free-solid-svg-icons";
const MembershipPrice = () => {
  return (
    <div className="membershipPriceContainer">
      <div className="membershipPriceContent">
        <div className="membershipPriceItem1">
          <h3>TYPE</h3>
        </div>
        <div className="membershipPriceItem2">
          <h3>PAY</h3>
        </div>
        <div className="membershipPriceItem3">
          <h3>LOAD</h3>
        </div>
        <div className="membershipPriceItem4">
          <h3>EXTRA BENEFITS</h3>
        </div>
        <div className="membershipPriceItem5">
          <h3>VALIDITY</h3>
        </div>
        <div className="membershipPriceItem31">
          <h3>PLATINUM</h3>
        </div>
        <div className="membershipPriceItem32">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            100000
          </h3>
        </div>
        <div className="membershipPriceItem33">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            150000
          </h3>
        </div>
        <div className="membershipPriceItem34">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            50000
          </h3>
        </div>
        <div className="membershipPriceItem35">
          <h3>3 YEARS</h3>
        </div>
        <div className="membershipPriceItem26">
          <h3>SAPPHIRE</h3>
        </div>
        <div className="membershipPriceItem27">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            75000
          </h3>
        </div>
        <div className="membershipPriceItem28">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            110000
          </h3>
        </div>
        <div className="membershipPriceItem29">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            35000
          </h3>
        </div>
        <div className="membershipPriceItem30">
          <h3>2 YEARS</h3>
        </div>
        <div className="membershipPriceItem21">
          <h3>DIAMOND</h3>
        </div>
        <div className="membershipPriceItem22">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            50000
          </h3>
        </div>
        <div className="membershipPriceItem23">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            75000
          </h3>
        </div>
        <div className="membershipPriceItem24">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            25000
          </h3>
        </div>
        <div className="membershipPriceItem25">
          <h3>2 YEARS</h3>
        </div>
        <div className="membershipPriceItem16">
          <h3>GOLD</h3>
        </div>
        <div className="membershipPriceItem17">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            30000
          </h3>
        </div>
        <div className="membershipPriceItem18">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            45000
          </h3>
        </div>
        <div className="membershipPriceItem19">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            15000
          </h3>
        </div>
        <div className="membershipPriceItem20">
          <h3>1 YEAR</h3>
        </div>

        <div className="membershipPriceItem11">
          <h3>RUBY</h3>
        </div>
        <div className="membershipPriceItem12">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            20000
          </h3>
        </div>
        <div className="membershipPriceItem13">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            27000
          </h3>
        </div>
        <div className="membershipPriceItem14">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            7000
          </h3>
        </div>
        <div className="membershipPriceItem15">
          <h3>1 YEAR</h3>
        </div>

        <div className="membershipPriceItem6">
          <h3>SILVER</h3>
        </div>
        <div className="membershipPriceItem7">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            10000
          </h3>
        </div>
        <div className="membershipPriceItem8">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            11000
          </h3>
        </div>
        <div className="membershipPriceItem9">
          <h3>
            <FontAwesomeIcon
              icon={faIndianRupee}
              className="menuIcon"
            ></FontAwesomeIcon>{" "}
            1000
          </h3>
        </div>
        <div className="membershipPriceItem10">
          <h3>1 YEAR</h3>
        </div>
      </div>
    </div>
  );
};

export default MembershipPrice;
